import React from 'react';
import propTypes from 'prop-types';

export const ChargeIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      viewBox="0 0 64 64"
      enableBackground="new 0 0 64 64"
      xmlsspace="preserve"
    >
      <polygon
        fill="none"
        stroke="#000000"
        strokeWidth="2"
        strokeLinejoin="bevel"
        strokeMiterlimit="10"
        points="40,1 17,37 31,37 
   24,63 50,27 36,27 "
      />
    </svg>
  );
};
ChargeIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
ChargeIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
